import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const internetHealthCheck: IMcAppType = {
  name: "internetHealthCheck",
  path: "/my/internet/health-check",
  description: "Internet Health Check",
  parameters: {
    properties: {},
  },
  navFlow: NavFlow.FOCUS,
  title: "Service health check",
  parent: Tab.USAGE,
  conditions: {
    intent: "internetHealthCheck",
    customerType: CustomerType.kraken,
  },
};
